import React, {
  memo, useCallback, useEffect, useMemo, useRef,
} from 'react';
import {
  func,
} from 'prop-types';
import noop from 'lodash/noop';
import includes from 'lodash/includes';
import omit from 'lodash/omit';
import Locale from '@active/react-utils/i18n/Locale';
import { useSelector, useDispatch } from 'react-redux';
import BillingContactForm from './components/BillingContactForm';
import { setBillingContact, setLatestBillingContact } from '../../paymentMethodsSlice';
import { useVerifyAVSMutation } from '../../../../../../../store/services/common/payment/paymentApi';
import { useLogTrackMutation } from '../../../../../../../store/services/common/logTrack/logTrackApi';
import { getBillingContactComponent } from '../../utils/getBillingInfo';
import SyncButton from '../../../../../passportWidgets/components/SyncButton';
import { useDeepEffect } from '../../../../../../../shared/utils/customizedHooks';

const BillingContactFormContainer = ({ trackingCallback }) => {
  const dispatch = useDispatch();
  const latestBilling = useRef(null);
  const { defaultBillingContact, widgetNameSpace } = useSelector(state => state.propsData);
  const { defaultData: { billingContact: defaultBillingContactData } = {} } = useSelector(state => state.mainStateData);
  const {
    entities: {
      paymentMethods: { defaultBillingContact: defaultBillingContactFromService },
    },
    isSupportAVS,
    billingContactConfig,
    latestBillingContact,
  } = useSelector(state => state.paymentMethods);

  const [ verifyAVS ] = useVerifyAVSMutation();
  const [ logTrack ] = useLogTrackMutation();

  // The prefill billingInfo are from 3ds return(defaultData), props, service respose,
  // and the usage priority is 3ds return > service respose > props
  const billingContact = useMemo(() => {
    const billingContactInfo = latestBillingContact || defaultBillingContactData
    || defaultBillingContactFromService
    || defaultBillingContact;

    if (!!billingContactConfig && !includes(billingContactConfig, 'EMAIL')) {
      return omit(billingContactInfo, [ 'email' ]);
    }
    return billingContactInfo;
  },
  [ defaultBillingContactData, defaultBillingContactFromService,
    defaultBillingContact, billingContactConfig, latestBillingContact ]);

  const onContactChange = useCallback((values) => {
    dispatch(setBillingContact(values));
    latestBilling.current = values;
  }, []);

  useDeepEffect(() => {
    dispatch(setBillingContact(billingContact));
    latestBilling.current = billingContact;
  }, [ billingContact ]);

  useEffect(() => {
    return () => {
      dispatch(setLatestBillingContact(latestBilling.current));
    };
  }, []);

  const BillingContact = useMemo(() => getBillingContactComponent(billingContactConfig), [ billingContactConfig ]);

  return (
    <div className="checkout-ui-component__payment-billing cui-mg-t-30">
      <div className='payment-billing__title'>
        <h4 className="cui-mg-b-0">
          <Locale id="checkout.lib.components.payment.paymentMethod.billing.title"/>
        </h4>
        <SyncButton trackingCallback={trackingCallback}/>
      </div>
      <BillingContactForm
        onContactChange={onContactChange}
        verifyAVS={verifyAVS}
        logTrack={logTrack}
        trackingCallback={trackingCallback}
        component={BillingContact}
        isSupportAVS={isSupportAVS}
        widgetNameSpace={widgetNameSpace}
        billingContact={billingContact}/>
    </div>
  );
};

BillingContactFormContainer.propTypes = {
  trackingCallback: func,
};

BillingContactFormContainer.defaultProps = {
  trackingCallback: noop,
};

export default memo(BillingContactFormContainer);
